import React from "react";

import "./CapacityItemStyle.css";

const CapacityItem = ({ icon, label }) => {
  return (
    <div className="capacity-item">
      <span className="icon">{icon}</span>
      <span className="label">{label}</span>
    </div>
  );
};

export default CapacityItem;
